<template>
    <div class="h-screen flex flex-col justify-center items-center py-2">
        <div class="admin-login-logo mb-20" style="width: 17%">
            <img
                class="object-cover"
                src="/images/logo-admin.svg"
                alt="KPAM-3D"
            />
        </div>
        <div class="admin-login-form mb-24 rounded-lg p-8">
            <div class="admin-login-form-header">
                {{ $t("admin.login.title") }}
            </div>

            <div
                v-if="error_message"
                class="text-sm text-red-400 mb-6"
                role="alert"
            >
                {{ error_message }}
            </div>

            <form @submit.prevent="submit">
                <div class="mb-4">
                    <input
                        id="email"
                        class="rounded focus:outline-none"
                        v-model="form.email"
                        placeholder="Email"
                        autofocus
                    />
                    <span
                        v-if="errors && errors.email"
                        class="text-sm text-red-400"
                        role="alert"
                    >
                        {{ errors.email[0] }}
                    </span>
                </div>

                <div class="mb-4">
                    <input
                        id="password"
                        type="password"
                        :placeholder="$t('admin.login.password')"
                        class="rounded focus:outline-none"
                        v-model="form.password"
                    />
                    <span
                        v-if="errors && errors.password"
                        class="text-sm text-red-400"
                        role="alert"
                    >
                        {{ errors.password[0] }}
                    </span>
                </div>

                <div>
                    <button type="submit" class="rounded">
                        {{ $t("admin.login.title") }}
                    </button>
                </div>
            </form>
        </div>

        <div class="copyright text-center text-sm">
            <div>
                KPam-3D v {{ version?.current_version_number }} - &copy; 2021-{{
                    currentYear
                }}
            </div>
            <div>{{ $t("admin.login.copyright") }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        form: {
            email: "",
            password: "",
        },
        errors: null,
        error_message: "",
        loading: false,
    }),

    methods: {
        async submit() {
            this.errors = null;
            this.error_message = "";
            this.loading = true;

            const formData = new FormData();

            formData.append("email", this.form.email);
            formData.append("password", this.form.password);

            try {
                const res = await axios.post(`/api/login`, formData);
                if (res.data.accessToken) {
                    localStorage.setItem("auth_token", res.data.accessToken);
                }
                location.reload();
            } catch (error) {
                console.log(error.response);
                if (
                    error.response.status == 422 ||
                    error.response.status == 401
                ) {
                    this.error_message =
                        error.response.data && error.response.data.error;
                }
                this.errors =
                    error.response &&
                    error.response.data &&
                    error.response.data.errors;
            } finally {
                this.loading = false;
            }
        },
    },

    computed: {
        version() {
            return this.$store.state.versions.version;
        },
        currentYear() {
            const d = new Date();
            return d.getFullYear();
        },
    },
};
</script>
